import { render, staticRenderFns } from "./PartnerModules.vue?vue&type=template&id=51543fc6&scoped=true"
import script from "./PartnerModules.vue?vue&type=script&lang=js"
export * from "./PartnerModules.vue?vue&type=script&lang=js"
import style0 from "./PartnerModules.vue?vue&type=style&index=0&id=51543fc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51543fc6",
  null
  
)

export default component.exports